import TopBottomBorderRadius from '../../../types/UI/TopBottomBorderRadius';

const borderRadiusForCard = (
    isFirst: boolean,
    isLast: boolean
): TopBottomBorderRadius => {
    if (isFirst && isLast) {
        return 'all';
    }

    if (isLast) {
        return 'bottom';
    }

    if (isFirst) {
        return 'top';
    }

    return 'none';
};

export default borderRadiusForCard;
